import { get } from '.';

export function GetOrganizationOrganizationUsers(id: string) {
	return get<any>(`/app/api/organizations/${id}/organization_users`);
}